import React, { useEffect, useState } from 'react'
import cn from 'classnames'
import styles from './Exchange.module.sass'
import Main from './Main'
import Balance from './Balance'
import Currency from './Currency'
import Trades from './Trades'
import Table from './Table'
import { useMediaQuery } from 'react-responsive'
import Charts from './Charts'
import { useSelector } from 'react-redux'
import { useSelectedMarket } from './Spot'
import { useMarketDepthSubscription } from '../../hooks/useMarketDepthSubscription'

const navigation = ['Chart', 'Order books', 'Trades']

const StandardLayout = ({ children, ...props }) => {
  const [activeIndex, setActiveIndex] = useState(0)
  const isTablet = useMediaQuery({ query: '(max-width: 1023px)' })
  const markets = useSelector((state) => state.crypto.markets.markets)
  const {
    selectedMarket,
    setSelectedMarket,
  } = useSelectedMarket();

  // Automatically manage depth subscriptions for the selected market
  useMarketDepthSubscription(selectedMarket);

  useEffect(() => {
    if (markets?.length > 0 && !selectedMarket) {
      setSelectedMarket(markets?.[0]?.instanceId)
    }
  }, [markets, selectedMarket])

  return (
    <div className={cn('exchange', styles.exchange)}>
      <Main selectedMarket={selectedMarket} />
      <div className={styles.nav}>
        {navigation.map((x, index) => (
          <button
            className={cn(styles.link, {
              [styles.active]: index === activeIndex,
            })}
            onClick={() => setActiveIndex(index)}
            key={index}
          >
            {x}
          </button>
        ))}
      </div>
      {isTablet ? (
        <>
          {children}
        </>
      ) : (
        <>
        <div className={styles.row}> 
          <div className={styles.col}>
            <Currency onMarketSelect={(x) => {
              setSelectedMarket(x)
            }} />
            <Trades selectedMarket={selectedMarket} />
          </div>
          <div className={styles.col}>
            <Charts selectedMarket={selectedMarket} />
            {children}
          </div>
          <div className={styles.col}>
            <Balance selectedMarket={selectedMarket} />
          </div>
        </div>
        <Table />
        </>
      )}
    </div>
  )
}

export default StandardLayout
